window.addEventListener("load", (e) => {
  const DatePicker = window.tui.DatePicker;

  let dataTime = [
    {
      label: "10:00 - 12:00",
      value: "10:00 - 12:00",
    },
    {
      label: "10:30 - 12:30",
      value: "10:30 - 12:30",
    },
    {
      label: "10:00 - 13:00",
      value: "10:00 - 13:00",
    },
    {
      label: "11:30 - 13:30",
      value: "11:30 - 13:30",
    },
    {
      label: "12:00 - 14:00",
      value: "12:00 - 14:00",
    },
    {
      label: "12:30 - 14:30",
      value: "12:30 - 14:30",
    },
    {
      label: "13:00 - 15:30",
      value: "13:00 - 15:30",
    },
    {
      label: "14:00 - 16:30",
      value: "14:00 - 16:30",
    },
    {
      label: "14:30 - 16:30",
      value: "14:30 - 16:30",
    },
    {
      label: "14:30 - 17:00",
      value: "14:30 - 17:00",
    },
  ];

  let blogDateEl = document.getElementById("jsBlogDate"),
    blogDateContainerEl = document.getElementById("jsBlogDateContainer");

  if (blogDateEl && blogDateContainerEl) {
    let blogDatePicker = new DatePicker(blogDateContainerEl, {
      input: {
        element: blogDateEl,
      },
      date: new Date(),
    });
    blogDatePicker.setDateFormat("yyyy/MM/dd");
  }

  let branchEl = document.getElementById("jsBranch");
  if (branchEl) {
    $("#jsBranch").select2();
  }

  let blogTimeEl = document.getElementById("jsBlogTime");
  if (blogTimeEl) {
    $("#jsBlogTime").select2();
  }

  let blogDatePopupEl = document.getElementById("jsBlogDatePopup"),
    blogDateContainerPopupEl = document.getElementById(
      "jsBlogDateContainerPopup"
    );

  if (blogDatePopupEl && blogDateContainerPopupEl) {
    let blogDatePickerPopup = new DatePicker(blogDateContainerPopupEl, {
      input: {
        element: blogDatePopupEl,
      },
      date: new Date(),
    });
    blogDatePickerPopup.setDateFormat("yyyy/MM/dd");
  }

  let branchPopupEl = document.getElementById("jsBranchPopup");
  if (branchPopupEl) {
    $("#jsBranchPopup").select2();
  }

  let blogTimePopupEl = document.getElementById("jsBlogTimePopup");
  if (blogTimePopupEl) {
    $("#jsBlogTimePopup").select2();
  }

  let blogAttributeEl = document.getElementById("jsBlogAttribute");
  if (blogAttributeEl) {
    $("#jsBlogAttribute").select2({
      placeholder: "Choose an option",
    });
  }
});
